import { authApi } from '@/api';
import { useMutation } from '@tanstack/react-query';

export const useUpdateUserDataWithoutRefetch = () => {
    const mutation = useMutation({
        mutationFn: authApi.updatedProfile,
        onError: (error) => {
            console.error('Error updating user data without refetch:', error);
        },
    });

    return mutation;
};
